import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import Box from "@mui/material/Box";
import { NavLink } from "react-router-dom";

import { setAppbarTitle, setDrawerTextWidth, setDrawerWidth } from "../../../actions/ui";
import { setCurrentType } from "../../../actions/projectmail";
import { PROJECTMAIL } from "../../../constants/router";

// import Notification from "./Notification";
import NotificationBell from "./NotificationBell";

const NavigationItemComponent = ({
  onClickFn,
  title,
  type,
  sideDrawerOpen,
  icon,
  sideDrawerTextWidth,
  setDrawerTextWidthFn,
  setDrawerWidthFn,
}) => {
  const textNode = useRef();
  const [minWidth, setMinWidth] = useState(undefined);

  useEffect(() => {
    if (textNode.current) {
      if (sideDrawerTextWidth < textNode.current.clientWidth) {
        setMinWidth(0);
        setDrawerWidthFn(150 + textNode.current.clientWidth); // 180
        setDrawerTextWidthFn(textNode.current.clientWidth);
      }
      if (minWidth !== sideDrawerTextWidth) {
        setMinWidth(sideDrawerTextWidth);
      }
    }
  }, [sideDrawerTextWidth, setDrawerTextWidthFn, setMinWidth, minWidth, setDrawerWidthFn]);

  const nestedSx = theme => ({ pl: theme.spacing(2) });
  const iconSx = { color: "rgba(0,0,0,0.54)" };
  const iconOpenSx = theme => ({
    color: "rgba(0,0,0,0.54)",
    minWidth: theme.spacing(7),
  });
  const titleSx = {
    flexGrow: 1,
    fontSize: "1rem",
    ...(minWidth ? { minWidth: `${minWidth}px` } : {}),
  };
  const noDisplaySx = { visibility: "hidden", fontSize: "1rem" };

  return sideDrawerOpen ? (
    <NavLink style={{ color: "inherit", textDecoration: "none" }} to={`${PROJECTMAIL}/${type}`}>
      <ListItem disablePadding key={type}>
        <ListItemButton sx={nestedSx} onClick={() => onClickFn(type)}>
          <Box sx={iconOpenSx}>{icon}</Box>
          <Box sx={titleSx}>{title}</Box>
          <NotificationBell type={type} />
          <Box ref={textNode} sx={noDisplaySx}>
            {title}
          </Box>
        </ListItemButton>
      </ListItem>
    </NavLink>
  ) : (
    <NavLink style={{ color: "inherit", textDecoration: "none" }} to={`${PROJECTMAIL}/${type}`}>
      <ListItem disablePadding key={type}>
        <ListItemButton sx={nestedSx} onClick={() => onClickFn(type)}>
          <Box sx={iconSx}>{icon}</Box>
        </ListItemButton>
      </ListItem>
    </NavLink>
  );
};

NavigationItemComponent.propTypes = {
  onClickFn: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  sideDrawerOpen: PropTypes.bool.isRequired,
  icon: PropTypes.object.isRequired,
  sideDrawerTextWidth: PropTypes.number.isRequired,
  setDrawerTextWidthFn: PropTypes.func.isRequired,
  setDrawerWidthFn: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  sideDrawerOpen: state.ui.sideDrawerOpen,
  sideDrawerTextWidth: state.ui.sideDrawerTextWidth,
});

const mapDispatchToProps = dispatch => ({
  onClickFn: type => {
    dispatch(setAppbarTitle("projectmail"));
    dispatch(setCurrentType(type));
  },
  setDrawerTextWidthFn: width => dispatch(setDrawerTextWidth(width)),
  setDrawerWidthFn: width => dispatch(setDrawerWidth(width)),
});

const NavigationItem = connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationItemComponent);

export default NavigationItem;
